import { Injectable } from '@angular/core';
import { BaseErrorHandlerModel, ExtendedServerErrorResponse, LoggingService } from '@app-core';

@Injectable({
    providedIn: 'root',
})
export class ConflictErrorHandlerService extends BaseErrorHandlerModel {
    override handle(error: ExtendedServerErrorResponse): void {
        LoggingService.log('ConflictErrorHandlerService::handle:', error);
        this.router.navigateByUrl('/not-actionable', { skipLocationChange: true });
    }
}
